export default __webpack_public_path__ + "static/media/gallery_03.3c672334.jpg";